export default __webpack_public_path__ + "images/76175f6f8568810ddde85c482638648e-hot_spot_icon.svg";